import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PatientPrescription } from '../Models/patientprescription.model';

@Injectable({
  providedIn: 'root',
})
export class PatientPrescriptionService {
  url = environment.Url + 'PatientPrescriptions';
  prescriptionDrugUrl =
    environment.Url + 'PatientPrescriptions/prescriptionDrugs';
  GivenUrl = environment.Url + 'PatientPrescriptions/givenStatus';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  registerPatientPrescription(body) {
    return this.http
      .post<PatientPrescription>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  saveMultiplePatientPrescriptions(body: PatientPrescription[]) {
    return this.http
      .post<PatientPrescription[]>(
        this.url + '/saveMultiplePatientPrescriptions',
        body
      )
      .pipe(catchError(this.handleError));
  }

  getPatientPrescriptions() {
    return this.http
      .get<PatientPrescription[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  getPatientPrescriptionById(id) {
    return this.http.get<PatientPrescription>(this.url + '/' + id);
  }

  getPatientPrescriptionDrugs(id) {
    return this.http.get<PatientPrescription>(
      this.prescriptionDrugUrl + '/' + id
    );
  }

  updatePatientPrescription(id, body) {
    return this.http
      .put<PatientPrescription>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deletePatientPrescription(id) {
    return this.http
      .delete<PatientPrescription>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid Prescription');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
